import { ToursMinimalIllustration } from '@carboncopyco/illustrations';
import { Button, Modal, Spacer, TextLargeParagraph } from '@carboncopyco/ui';
import type React from 'react';

interface StartTourCaptureModalProps {
  anchorRef?: React.RefObject<HTMLElement>;
  open?: boolean;
  onConfirm?: () => void;
  description: string;
}

function StartTourCaptureModal({
  anchorRef,
  open,
  onConfirm,
  description,
}: StartTourCaptureModalProps) {
  return (
    <Modal
      open={open}
      anchorRef={anchorRef}
      onClose={() => undefined}
      removeCloseIcon
    >
      <div className="flex flex-col items-center w-ds-500 px-2 select-none">
        <div className="py-4">
          <ToursMinimalIllustration />
        </div>
        <Spacer />
        <div className="w-ds-400 flex flex-auto text-center">
          <TextLargeParagraph
            label={description}
            color="text-ds-natural-600"
          />
        </div>
        <Spacer amount={1.5} />
        <Button
          label="Got it"
          onClick={onConfirm}
        />
      </div>
    </Modal>
  );
}

export default StartTourCaptureModal;
